var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"filters-tag-list"},_vm._l((_vm.tags),function(tag,i){return _c('b-col',{key:tag.id,staticClass:"mb-2",attrs:{"cols":"12","lg":"6"}},[_c('tag',{attrs:{"tag":tag,"index":i + 1}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }